export interface HighRiskEventOption {
  readonly label: string;
  readonly value: string;
}

export const HIGH_RISK_EVENT_OPTIONS: readonly HighRiskEventOption[] = [
  { label: 'All', value: 'All' },
  { label: '1 ≤ and <5', value: '1' },
  { label: '5 ≤ and <10', value: '2' },
  { label: '10 ≤', value: '3' }
];

export const HIGH_RISK_EVENT_LABELS: Readonly<Record<string, string>> =
  HIGH_RISK_EVENT_OPTIONS.reduce<Record<string, string>>((labels, option) => {
    labels[option.value] = option.label;
    return labels;
  }, {});
